<template>
  <div class="info-title-params">
    <stars-rating
      class="info-title-params__rating"
      :value="rating"
    />
    <ui-badge
      :text="counter"
      color="#000"
    />
  </div>
</template>

<script>
import StarsRating from '@/components/product/review-stats/stars-rating.vue';

export default {
  name: 'info-title-params',

  components: { StarsRating },

  props: {
    rating: {
      type: Number,
      default: 0,
    },
    counter: {
      type: Number,
      default: 0,
    }
  },
}
</script>

<style lang="scss">
  .info-title-params {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>